import { Typography, Box, useTheme, useMediaQuery } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import InfoPng from 'Components/images/info.png'
import ProjectPng from 'Components/images/Project icone Big.png'
import DescriptionPng from 'Components/images/description.png'
import { Input } from 'Components/Input'
import Modal from '@mui/material/Modal'
import { useForm } from 'react-hook-form'
import { convertToMuiDate } from 'utils/helpers'
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import SaveIcon from '@mui/icons-material/Save'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import { makePutRequest, makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import ComboBox from 'Components/ComboBox'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 400 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
  },
}))

const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  overflowY: 'auto',
  height: '70%',
}

function AddModal(props) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteUser = useSelector((store) => store.user)

  const [statutText, setStatutText] = useState('')
  const [statutColor, setStatutColor] = useState('')
  const [checkListsPercentage, setCheckListsPercentage] = useState(0)
  const [domain, setDomain] = useState([])
  const [selectedDomain, setSelectedDomain] = useState({})

  useEffect(() => {
    setValue('LifeDomain', props.row.LifeDomain ? props.row.LifeDomain : '')
    setValue('Objectifs', props.row.Objectifs ? props.row.Objectifs : '')
    setValue('id', props.row.id ? props.row.id : '')
    setValue(
      'DateFinObjectif',
      props.row.DateFinObjectif ? convertToMuiDate(props.row.DateFinObjectif) : '',
    )
    setSelectedDomain(
      props.row.LifeDomain ? { label: `${props.row.domain.domain}`, id: props.row.domain.id } : '',
    )
    setValue(
      'LifeDomain',
      props.row.LifeDomain ? { label: `${props.row.domain.domain}`, id: props.row.domain.id } : '',
    )
    let total = props.row.tasks?.length
    let done = 0
    props.row.tasks?.map((v) => {
      if (v.Done) done++
      return ''
    })

    setCheckListsPercentage((done / total) * 100)
    let text = ''
    let color = ''

    if (total === done) {
      text = t('mesToDo.statusDone')
      color = 'green'
    } else if (done === 0) {
      text = t('mesToDo.statusNotStarted')
      color = 'red'
    } else if (done > 0 && done < total) {
      text = t('mesToDo.statusInProgress')
      color = '#a37a00'
    }
    setStatutColor(color)
    setStatutText(text)
  }, [])

  useEffect(() => {
    fetchDomain()
  }, [])

  const fetchDomain = async () => {
    const url = urls.getDomain + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.domain}`, id: v.id })
      })
      setDomain([...filterTypes])
    }
  }

  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {},
  })
  const onSubmit = async (data) => {
    let payload = {}

    payload = {
      ...data,
      DateFinObjectif: data.DateFinObjectif ? data.DateFinObjectif : null,
      LifeDomain: data.LifeDomain.id,
    }
    const response = await makePutRequest(urls.projectOperations + `${data.id}/`, payload, {}, true)
    if (response.status === 200) {
      props.handleModelClose()
      props.fetchOperations()
    }
  }
  return (
    <>
      <Modal
        open={props.modelOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={mstyle}>
          <Box>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box
                sx={{
                  textAlign: 'end',
                  padding: '5px 10px',
                }}
              >
                <Button type="submit">
                  <SaveIcon />
                </Button>
                <Button>
                  <CloseIcon
                    sx={{
                      cursor: 'pointer',
                    }}
                    onClick={props.handleModelClose}
                  />
                </Button>
              </Box>
              <Box sx={{ padding: '0 15px' }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 0',
                    marginTop: '-30px',
                  }}
                >
                  <Box
                    sx={{
                      padding: '0 5px',
                    }}
                  >
                    <img alt="" style={{ height: '42px' }} src={ProjectPng} />
                  </Box>
                  <Box>
                    <Typography
                      id="modal-modal-title"
                      sx={{
                        color: 'black !important',
                        textAlign: 'left',
                      }}
                      variant="h7"
                      component="h4"
                    >
                      {props.row.Name}
                    </Typography>
                    <Typography id="modal-modal-description">
                      {t('mesToDo.createdOn')}{' '}
                      {props.row.DateCreation
                        ? convertToUserDateFormate(siteUser.user, props.row.DateCreation)
                        : ''}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 0',
                    marginTop: 2,
                  }}
                >
                  <Box
                    sx={{
                      padding: '0 5px',
                    }}
                  >
                    <img alt="" src={InfoPng} />
                  </Box>
                  <Box
                    sx={{
                      width: '-webkit-fill-available',
                      paddingRight: '30px',
                    }}
                  >
                    <Typography
                      id="modal-modal-title"
                      sx={{
                        color: 'black !important',
                        textAlign: 'left',
                      }}
                      variant="h7"
                      component="h6"
                    >
                      {t('mesToDo.progress')}
                    </Typography>
                    <Box
                      component="span"
                      variant="span"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '5px 0',
                      }}
                    >
                      <Box
                        sx={{
                          padding: '0 5px',
                        }}
                      >
                        {checkListsPercentage ? parseFloat(checkListsPercentage).toFixed(2) : 100}%
                      </Box>
                      <Box sx={{ flexGrow: 1 }}>
                        <BorderLinearProgress
                          variant="determinate"
                          value={checkListsPercentage ? checkListsPercentage : 100}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: { sm: '1fr 1fr 1fr' },
                    padding: '0 25px',
                  }}
                >
                  <ComboBox
                    handleAutoComplete={(e, j) => {
                      setValue('LifeDomain', j)
                      setSelectedDomain(j)
                    }}
                    label={t('mesToDo.fieldDomain')}
                    data={domain}
                    name="LifeDomain"
                    required={true}
                    selectedValue={selectedDomain}
                  />

                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      size: 'small',
                      type: 'date',
                    }}
                    name="DateFinObjectif"
                    label={t('mesToDo.fieldDeadline')}
                    InputLabelProps={{ shrink: true }}
                  />
                  <Box>
                    <Box sx={{ fontWeight: 'bold' }}>{t('mesToDo.fieldStatus')}</Box>
                    <Box sx={{ color: statutColor, fontWeight: 'bold', fontSize: 'lager' }}>
                      {statutText}
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 0',
                    marginTop: 2,
                  }}
                >
                  <Box
                    sx={{
                      padding: '0 5px',
                    }}
                  >
                    <img alt="" src={DescriptionPng} />
                  </Box>
                  <Box>
                    <Typography
                      id="modal-modal-title"
                      sx={{
                        color: 'black !important',
                        textAlign: 'left',
                      }}
                      variant="h7"
                      component="h4"
                    >
                      {t('mesToDo.description')}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: { sm: '1fr' },
                    padding: '0 10px',
                  }}
                >
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      size: 'small',
                      type: 'text',
                    }}
                    rows={4}
                    multiline
                    name="Objectifs"
                    label={t('mesToDo.description')}
                  />
                </Box>
              </Box>
            </form>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

function ListOperations({
  fetchOperations,
  operations,
  setSelectedRows,
  setProjectTaskId,
  setProjectTaskName,
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const siteUser = useSelector((store) => store.user)
  const [modifiedColumns, setModifiedColumns] = useState([])

  let navigate = useNavigate()

  const [modelOpen, setModelOpen] = useState(false)
  const [rowData, setRowData] = useState([])
  const handleModelOpen = () => setModelOpen(true)
  const handleModelClose = () => setModelOpen(false)

  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (searchParams.has('p') && searchParams.get('p')) {
      if (parseInt(searchParams.get('p'))) {
        if (operations.results) {
          let op = operations.results.find((e) => e.id === parseInt(searchParams.get('p')))

          setProjectTaskId(op.id)
          setProjectTaskName(op.Name)
          navigate('/todos/taches')
        }
      }
    }
  }, [operations])

  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  useEffect(() => {
    if (isMobile) {
      setModifiedColumns([
        {
          field: 'Nom',
          headerName: t('mesToDo.colName'),
          width: 210,
          // valueGetter: (params) => `${params.row.Nom?.Nom || params.row.IBAN}`,
          renderCell: (params) => {
            let done = 0
            let taskslist = params.row.tasks
            taskslist.map((v) => {
              if (v.Done) done++
              return ''
            })
            let text = done + '/' + taskslist.length

            let total = params.row.tasks?.length
            done = 0
            params.row.tasks?.map((v) => {
              if (v.Done) done++
              return ''
            })
            let checkListsPercentage = done === 0 ? 0 : (done / total) * 100
            return (
              <Box py={2} mt={1}>
                <Box fontWeight={600}>{params.row.Name}</Box>
                <Box>
                  <Box component={'span'}>{t('mesToDo.tasksLabel')}:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {text}
                  </Box>
                </Box>
                <Box>
                  <Box component={'span'}>{t('mesToDo.progress')}:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {parseFloat(checkListsPercentage).toFixed(2)}%
                  </Box>
                </Box>
                <Box>
                  <Box component={'span'}>{t('mesToDo.endDate')}:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {convertToUserDateFormate(siteUser.user, params.row.DateFinObjectif)}
                  </Box>
                </Box>
                <Box>
                  <Box component={'span'}>{t('mesToDo.fieldDomain')}:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {params.row.LifeDomain ? params.row.domain.domain : ''}
                  </Box>
                </Box>
              </Box>
            )
          },
        },
        {
          field: 'Statut',
          headerName: t('mesToDo.fieldStatus'),
          width: 130,
          type: 'number',
          renderCell: (params) => {
            let done = 0
            let tasks = params.row.tasks
            tasks.map((v) => {
              if (v.Done) done++
              return ''
            })
            let text = ''
            let color = ''
            if (tasks.length === done) {
              text = t('mesToDo.statusDone')
              color = 'green'
            } else if (done === 0) {
              text = t('mesToDo.statusNotStarted')
              color = 'red'
            } else if (done > 0 && done < tasks.length) {
              text = t('mesToDo.statusInProgress')
              color = '#a37a00'
            }
            return (
              <Box
                sx={{
                  fontWeight: 600,
                  color: color,
                  width: '-webkit-fill-available',
                  textAlign: 'center',
                }}
              >
                {text}
              </Box>
            )
          },
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile])

  const columns = [
    {
      field: 'Name',
      headerName: t('mesToDo.colName'),
      width: 160,
      editable: true,
      renderCell: (params) => params.row.Name,
    },
    {
      headerName: t('mesToDo.colTasks'),
      width: 80,
      editable: true,
      renderCell: (params) => {
        let done = 0
        let taskslist = params.row.tasks
        taskslist.map((v) => {
          if (v.Done) done++
          return ''
        })
        let text = done + '/' + taskslist.length
        return <Box>{text}</Box>
      },
    },
    {
      field: 'tasks',
      headerName: t('mesToDo.progress'),
      width: 300,
      editable: true,
      renderCell: (params) => {
        let total = params.row.tasks?.length
        let done = 0
        params.row.tasks?.map((v) => {
          if (v.Done) done++
          return ''
        })
        let checkListsPercentage = done === 0 ? 0 : (done / total) * 100
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              padding: '5px 0',
            }}
            component="span"
            variant="span"
            onClick={() => {
              setRowData(params.row)
              handleModelOpen()
            }}
          >
            <Box
              sx={{
                padding: '0 5px',
              }}
              component="span"
              variant="span"
            >
              {parseFloat(checkListsPercentage).toFixed(2)}%
            </Box>
            <Box sx={{ flexGrow: 1, minWidth: '240px' }} component="span" variant="span">
              <BorderLinearProgress variant="determinate" value={checkListsPercentage} />
            </Box>
          </Box>
        )
      },
    },
    {
      field: 'DateFinObjectif',
      headerName: t('mesToDo.endDate'),
      width: 100,
      editable: false,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.DateFinObjectif),
    },
    {
      field: 'Statut',
      headerName: t('mesToDo.fieldStatus'),
      width: 110,
      editable: false,
      renderCell: (params) => {
        let done = 0
        let tasks = params.row.tasks
        tasks.map((v) => {
          if (v.Done) done++
          return ''
        })
        let text = ''
        let color = ''
        if (tasks.length === done) {
          text = t('mesToDo.statusDone')
          color = 'green'
        } else if (done === 0) {
          text = t('mesToDo.statusNotStarted')
          color = 'red'
        } else if (done > 0 && done < tasks.length) {
          text = t('mesToDo.statusInProgress')
          color = '#a37a00'
        }
        return (
          <Box sx={{ color: color, width: '-webkit-fill-available', textAlign: 'center' }}>
            {text}
          </Box>
        )
      },
    },
    {
      field: 'LifeDomain',
      headerName: t('mesToDo.fieldDomain'),
      width: 110,
      editable: true,
      valueGetter: (params) => `${params.row.LifeDomain ? params.row.domain.domain : ''}`,
    },
  ]

  return (
    <div
      style={{
        height: 750,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
        paddingBottom: 54,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {t('mesToDo.projectsTitle', { count: operations.count })}
      </Typography>
      <DataGrid
        sx={{
          '.MuiDataGrid-footerContainer': { background: 'aliceblue' },
          '.MuiTablePagination-toolbar': { alignItems: 'baseline' },
        }}
        rows={operations.results ? operations.results : []}
        columns={modifiedColumns}
        pageSize={rows}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
        disableSelectionOnClick
        onRowClick={(params, event) => {
          if (event.target.localName === 'div') {
            setProjectTaskId(params.id)
            setProjectTaskName(params.row.Name)
            navigate('/todos/taches')
          }
        }}
      />
      {modelOpen && (
        <AddModal
          modelOpen={true}
          handleModelClose={handleModelClose}
          row={rowData}
          fetchOperations={fetchOperations}
        />
      )}
    </div>
  )
}
export default ListOperations
